export default {
  setUserData(state, payload) {
    if (!state || !payload) return;
    state.user = payload;
  },
  setUserDataError(state, payload) {
    state.error = payload;
  },
  setShowSmsCodeInput(state, value) {
    state.showSmsCodeInput = value;
  },
  saveUserPhone(state, userData) {
    state.userPhone = userData.userPhone;
  },
  saveUserName(state, userData) {
    state.userName = userData.userName;
  },
  saveUserFirstName(state, userData) {
    state.firstName = userData.firstName;
  },
  saveUserLastName(state, userData) {
    state.lastName = userData.lastName;
  },
  saveUserBirthDate(state, userData) {
    state.birthDate = userData.birthDate;
  },
  setAuthErrorMessage(state, text) {
    state.authErrorNotification = text;
  },
  setAuthStatus(state, status) {
    state.authStatus = status;
  }
};
